export enum TimeZoneUTCType {
  'GMT+00 Coordinated Universal Time' = '+0000',
  'GMT-06 Central American Time' = '-0600',
  'GMT-05 Eastern Standard Time' = '-0500', // Winter
  'GMT-04 Eastern Daylight Time' = '-0400', // Summer
  'GMT-07 Pacific Time' = '-0700',
}
